<div class="container-fluid" *ngIf="!brand">
    <div class="row">
        <div class="col-md-12">
        	<app-preloader *ngIf="loadBrands"></app-preloader>
            <div class="brand-wrap">
            	<a [routerLink]="['/wheelbrand', brand.name]" *ngFor="let brand of allBrands">
                    <img [src]="brand.image | imagePath" alt="{{ brand.name }}" />
                </a>
            </div>

            <div class="row text-center" *ngIf="!loadMoreBrands && hasNextPage && !loadBrands && allBrands.length">
            	<div class="col-12">
            		<button type="button" class="btn btn-primary" (click)="loadMore()">Load More</button>
            	</div>
            </div>
            <app-preloader *ngIf="loadMoreBrands"></app-preloader>
            <app-not-found *ngIf="!allBrands?.length && !loadBrands"></app-not-found>

        </div>
    </div>
</div>




<section class="mt-5" *ngIf="brand && !product">
    <div class="container-fluid">
        <div class="top-section d-flex align-items-center">
            <a [routerLink]="['/wheelbrand']">
                <i class="fa fa-long-arrow-left"></i>
            </a>
            <div class="logo-wrap">
                <img [src]="brandProducts.image | imagePath" alt="{{brandProducts.name}}" />
            </div>
        </div>
    </div>

    <div class="listing-section">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 bg-white">
                    <div class="listing-wrap">
                        <a [routerLink]="['/wheelbrand', brandProducts.name, product.slug]" *ngFor="let product of brandProducts.products" class="listing-box">
                            <div class="listing-image">
                                <img [src]="product.images | baseImage | imagePath" />
                            </div>
                            <h5>{{ product.name }}</h5>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>






<section class="pt-5" *ngIf="brand && product" style="background-color: #F2F1F3; overflow: hidden;">
    <div class="container-fluid">
        <div class="top-section d-flex align-items-center mb-0">
            <a [routerLink]="['/wheelbrand', brand]">
                <i class="fa fa-long-arrow-left"></i>
            </a>
            <div class="logo-wrap">
                <img [src]="brandProductVariants.image | imagePath" />
            </div>
            <h4 class="mb-0 new-font">{{ brandProductVariants.product.name }}</h4>
        </div>
        
    </div>

    <div class="listing-section bg-white" >
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                            <h3 class="text-left f-26 d-flex align-items-end new-font h-100 pb-3">More Size & Options</h3>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
                            <div class="right-img">
                                <img [src]="brandProductVariants.product.images | baseImage | imagePath" />
                            </div>
                           
                        </div>
                        <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                            <ul class="nav nav-tabs nav-justified search-nav-tabs details-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation" *ngFor="let type of wheelSizeTypes">
                                    <a class="nav-link" [class.active]="activeTab==''" data-toggle="tab" href="{{type}}" (click)="getVariantsData(brandProductVariants.product.id, type)">{{ type }}″</a>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                                    <div class="table-responsive">
                                        <table class="table details-table ">
                                            <thead>
                                                <tr>
                                                    <th>Part No.</th>
                                                    <th>Finish</th>
                                                    <th>Size</th>
                                                    <th>Bolt Pattern</th>
                                                    <th>Offset</th>
                                                    <th>Weight</th>
                                                    <th>Stock</th>
                                                    <th></th>
                                                </tr>
                                            </thead>

                                            <tbody *ngIf="moreSizes.length > 0">
                                                <tr *ngFor="let size of moreSizes">
                                                    <td><a [routerLink]="['/', product, size.sku]" class="no-styling">{{ size.sku }}</a></td>
                                                    <td>{{ brandProductVariants.product.finish?.finish }}</td>
                                                    <td>{{ size.size }}</td>
                                                    <td>{{ size.bolt_pattern }}</td>
                                                    <td>{{ size.offset }}</td>
                                                    <td>{{ size.weight }}</td>
                                                    <td *ngIf='size.total_quantity > 0'><span class='in-stk'>In Stock</span></td>
                                                    <td *ngIf='size.total_quantity <= 0'><span class='out-stk'>Out Of Stock</span></td>
                                                    <td><a [routerLink]="['/', product, size.sku]" class="no-styling">View</a></td>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="moreSizes.length <= 0">
                                                <tr>
                                                    <td colspan="8"><h6 class="alert alert-danger">No Variants Found</h6></td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


